import { Component, ViewChild } from '@angular/core';
import { asyncScheduler, filter, map, Observable, observeOn } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { AuditManager } from '../../../managers/audit.manager';
import { AuditLog } from '../../../models/ui/audit-log.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { HelpService } from '../../../services/help.service';

@Component({
    selector: 'lex-audit',
    templateUrl: './audit.component.html',
    styleUrls: ['./audit.component.scss'],
    standalone: false
})
export class AuditComponent {
	public totalEntries$: Observable<number>;
	public hasPreviousPage$: Observable<boolean>;
	public hasNextPage$: Observable<boolean>;
	public dataSource$: Observable<MatTableDataSource<AuditLog>>;
	private skip: number;
	private take: number;
	private sortColumn: string = 'accessDateTime';
	private sortDirection: 'asc' | 'desc' = 'desc';

	public columnsToDisplay = [
		'dateAccessed',
		'documentName',
		'username',
		'case'
	];

	@ViewChild('paginator', { static: false }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: false }) matSort: MatSort;

	constructor(private auditManager: AuditManager,
				private dialog: MatDialog,
				private snackBar: MatSnackBar,
				private helpService: HelpService
	) {
		this.helpService.updateHelpLink('account-menu/audit-doc-access');
		this.refreshData();

		this.dataSource$ = this.auditManager.auditLogCollection$.pipe(
			filter((collection) => !!collection),
			map((logCollection) => new MatTableDataSource(logCollection?.logs)),
		);

		this.totalEntries$ = this.auditManager.auditLogCollection$.pipe(
			map((collection) => collection?.totalItems || 0)
		);

		this.hasNextPage$ = this.totalEntries$.pipe(
			observeOn(asyncScheduler),
			map(() => this.paginator?.hasNextPage())
		);

		this.hasPreviousPage$ = this.totalEntries$.pipe(
			observeOn(asyncScheduler),
			map(() => this.paginator?.hasPreviousPage())
		);
	}

	public loadPreviousPage(): void {
		this.paginator?.previousPage();
	}

	public loadNextPage(): void {
		this.paginator?.nextPage();
	}

	public movePage(event): void {
		this.skip = event.pageIndex * event.pageSize;
		this.take = event.pageSize;
		this.refreshData();
	}

	public openDocument(id: string): void {
		window.open(`/review/doc-viewer?DocId=${ id }`, 'DocViewer');
	}

	public export(): void {
		this.auditManager.exportAuditLogs();
	}

	public sort($event): void {
		this.sortColumn = $event.active;
		this.sortDirection = $event.direction;
		this.refreshData();
	}

	public refreshData(): void {
		this.auditManager.refreshAuditLogs({
			skip: this.skip || 0,
			take: this.take || 25,
			orderByColumn: this.sortColumn,
			orderByDirection: this.sortDirection
		});
	}
}
